import { createAction as realCreateAction } from 'redux-act';
export const createAction = desc => {
  const ns = '[CART]';
  return realCreateAction(`${ns} ${desc}`);
};
export default createAction;